"use client";

import { useState } from "react";

type ColorSwatchProps = {
  name: string;
  hex: string;
  rgb: string;
  token: string;
};

export function ColorSwatch({ name, hex, rgb, token }: ColorSwatchProps) {
  const [copied, setCopied] = useState(false);

  async function copyHex() {
    await navigator.clipboard.writeText(hex);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  }

  return (
    <button
      type="button"
      onClick={copyHex}
      className="group text-left"
      aria-label={`Copy ${name} hex value ${hex}`}
    >
      <span
        aria-hidden="true"
        className="border-border block h-24 rounded-md border-[0.5px]"
        style={{ backgroundColor: hex }}
      />
      <span className="mt-3 flex items-start justify-between gap-4">
        <span>
          <span className="text-foreground block text-sm font-medium">
            {name}
          </span>
          <span className="text-muted-foreground mt-1 block text-sm">
            {hex}
          </span>
          <span className="text-muted-foreground block text-xs">{rgb}</span>
          <span className="text-muted-foreground block text-xs">{token}</span>
        </span>
        <span className="text-primary min-w-12 text-right text-xs font-medium opacity-0 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100">
          {copied ? "Copied" : "Copy"}
        </span>
      </span>
    </button>
  );
}
